var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOmg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32792)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.03206 9.999L7.89019 6.85013H6.91875V10.9693H7.61906V8.06737L8.67881 10.9693H9.36731L10.4259 8.06737V10.9693H11.1437V6.85013H10.1734L9.03206 9.999ZM4.31494 6.75C3.05044 6.75 2.25 7.70344 2.25 8.91281C2.25 10.1216 3.05044 11.0728 4.31494 11.0728C5.57944 11.0728 6.38156 10.1284 6.38156 8.91281C6.38156 7.69669 5.58169 6.75 4.31494 6.75ZM4.31494 10.3404C3.50888 10.3404 3.02681 9.73406 3.02681 8.91563C3.02681 8.09663 3.50888 7.48631 4.31494 7.48631C5.121 7.48631 5.60475 8.09831 5.60475 8.91281C5.60475 9.72675 5.12212 10.3404 4.31494 10.3404ZM13.5776 9.47025H14.76C14.6902 10.071 14.2538 10.3534 13.6946 10.3534C12.8942 10.3534 12.4481 9.76444 12.4481 8.91675C12.4481 8.12194 12.8413 7.46944 13.6777 7.46944C14.2245 7.46944 14.6666 7.74844 14.7139 8.217H15.4958C15.39 7.27537 14.6717 6.75112 13.7014 6.75112C12.3238 6.75112 11.682 7.81088 11.682 8.94038C11.682 10.1537 12.4245 11.0711 13.5776 11.0711C14.2537 11.0711 14.6318 10.7584 14.7836 10.494V10.9648H15.4958V8.76206H13.5776V9.47025Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32792"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOmg);
export default __webpack_public_path__ + "static/media/omg.8e21cfc8a716f6cba94ed10831487507.svg";
export { ForwardRef as ReactComponent };